export default __webpack_public_path__ + "static/media/debug.ab714c9e.gif";